import { FunctionalComponent, h } from '@stencil/core';
import classnames from 'classnames';

interface TextProps {
    antialiased?: boolean;
    component?: string;
    color?: string;
    content?: string;
    decoration?: string;
    size?: string;
    transformCase?: string;
    truncated?: any;
    weight?: string;
};

const Text: FunctionalComponent<TextProps> = ({ component: ComponentClass = 'span', color, weight, transformCase, decoration, size, antialiased, content, truncated }) => {
    const getSizeClasses = (sizes: string) => {
        if (['number', 'string'].includes(typeof sizes)) {
            return [`text-size-${parseInt(sizes, 10)}`];
        }

        try {
            return Object.keys(sizes).map((breakpoint) => (
                `text-size${breakpoint === 'xs' ? '' : `-${breakpoint}`}-${sizes[breakpoint]}`
            ));
        } catch (e) {
            return null;
        }
    }

    const classNames = classnames({
        [`text-${color}`]: color && color !== 'default',
        [`text-${weight}`]: weight,
        [`text-${transformCase}`]: transformCase,
        [`text-${decoration}`]: decoration,
        'text-antialiased': antialiased,
        'text-truncated': truncated,
    },
        getSizeClasses(size),
    );

    return (
        <ComponentClass
            class={classNames}
        >
            {content}
        </ComponentClass>
    );
}

export default Text;